// @flow
import { AuthActionTypes } from './constants';

// common success
export const authApiResponseSuccess = (actionType, data) => ({
    type: AuthActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

// common error
export const authApiResponseError = (actionType, error) => ({
    type: AuthActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

// export const loginUser = (email, password) => ({
//     type: AuthActionTypes.LOGIN_USER,
//     payload: { email, password },
// });

export const loginUser = (contact) => ({
    type: AuthActionTypes.LOGIN_USER,
    payload: { contact },
});

export const logoutUser = (email) => ({
    type: AuthActionTypes.LOGOUT_USER,
    payload: { email },
});

export const signupUser = (fullname, email, password) => ({
    type: AuthActionTypes.SIGNUP_USER,
    payload: { fullname, email, password },
});

export const forgotPassword = (username, contact) => ({
    type: AuthActionTypes.FORGOT_PASSWORD,
    payload: { username, contact },
});

export const forgotPasswordChange = (username) => ({
    type: AuthActionTypes.FORGOT_PASSWORD_CHANGE,
    payload: { username },
});

export const resetAuth = () => ({
    type: AuthActionTypes.RESET,
    payload: {},
});

export const mobileVerification = (contact) => ({
    type: AuthActionTypes.MOBILE_VERIFICATION,
    payload: { contact },
});

export const userVerification = (userId, password) => ({
    type: AuthActionTypes.USER_VERIFICATION,
    payload: { userId, password },
});

export const updateUserAfterStationAdd = (data) => ({
    type: AuthActionTypes.UPDATE_USER_AFTER_STATION_ADD,
    payload: data,
});
